// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCurtain_root__DmDc6","rootOpen":"ModalCurtain_rootOpen__3VffV"};